import {Grid} from "@mui/material";
import {useEffect, useState} from "react";
import {API} from "../framework/api";
import {isAdministrator} from "../framework/utils";
import {Menu} from "../component/Menu";
import {MENU_ITEMS} from "../framework/constants";
import {CompetenceArea} from "../component/CompetenceArea";
import {ReplyArea} from "../component/ReplyArea";
import {AssignmentReplies} from "../component/AssignmentReplies";

export function AdminProfilePage(props) {
  const [username, setUsername] = useState('');
  const [searchResult, setSearchResult] = useState([]);

  const [values, setValues] = useState({
    competences: '',
    email: '',
    freeText: '',
    experience: '',
  });

  useEffect(() => {
    let username = document.location.hash.substr(document.location.hash.lastIndexOf('/') + 1);
    setUsername(username);
    updateAssignments();

    API.getAPI().get_user_info(username).then((response)=> {
      setValues({ ...values,
        competences: (response.data.competences ?? ''),
        email: (response.data.email ?? ''),
        freeText: (response.data.freeText ?? ''),
        experience: (response.data.experience ?? ''),
      });
    });
  }, []);

  if (!isAdministrator()) {
    document.location.hash = "#/anslagstavlan";
    return;
  }

  const updateAssignments = () => {
    let username = document.location.hash.substr(document.location.hash.lastIndexOf('/') + 1);
    API.getAPI().admin_search({username}).then((response) => {
      setSearchResult(response.data);
    });
  };

  return (
    <div>
      <div className={"App-title-withSubtitle"}>Anslagstavlan [ADMIN]</div>
      <div className={"App-subTitle"}>Funktioner för administratörer.</div>
      <Grid container={true} spacing={0} className={"App-drop-shadow"}>
        <Grid item xs={3} sm={3} className={"App-container-leftMenu"}>
          <Menu items={MENU_ITEMS} />
        </Grid>
        <Grid item xs={9} sm={9} className={"App-container-rightContent"}>
          <div className={"App-rightContent"}>
            <Grid container={true} spacing={0}>

              {/*** App Right content ***/}

              <Grid item xs={12} sm={12}>
                <div className={"App-fieldTitle"}>Profil för '{username}'</div>
              </Grid>
              <Grid item xs={12} sm={12}>

                {/*** Competences ***/}
                <CompetenceArea competences={values.competences} readOnly={true} />

              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={"App-fieldTitle"}>E-post</div>
              </Grid>
              <Grid item xs={12} sm={12}>

                {values.email ? values.email : 'Ej angiven'}

              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={"App-fieldTitle"}>Erfarenhet</div>
              </Grid>
              <Grid item xs={12} sm={12}>

                {values.experience ? values.experience : '-'}

              </Grid>
            </Grid>
          </div>
          <Grid container={1} spacing={0}>
            {searchResult.map((result, i) => (
              <Grid item xs={12} md={12}>
                <div className={"App-rightContent"}>
                  <Grid container={1} spacing={1}>
                    <Grid item xs={8} md={8}>
                      <div className={"App-fieldTitle"}>Uppdrag {i + 1}</div>
                    </Grid>
                    <Grid item xs={4} md={4}>
                      <div className={"u-textRight u-fontSize12 u-paddingT10 u-colorDimmed"}>Inlagd: {result.createdAt}</div>
                    </Grid>
                  </Grid>
                  <div>{result.assignmentText}</div>
                  <div>
                    <AssignmentReplies replies={result.replies} />
                  </div>
                  <div className={"u-textRight"}>
                    <ReplyArea assignmentId={result.id} onChange={updateAssignments} />
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
          {searchResult.length === 0 ?
            <Grid container={1} spacing={0}>
                <Grid item xs={12} md={12}>
                  <div className={"App-rightContent"}>
                    <Grid container={1} spacing={1}>
                      <Grid item xs={8} md={8}>
                        <div className={"App-fieldTitle"}>Inga önskeuppdrag inlagda</div>
                      </Grid>
                      <Grid item xs={4} md={4}>
                        <div className={"u-textRight u-fontSize12 u-paddingT10 u-colorDimmed"}>Inlagd: -</div>
                      </Grid>
                    </Grid>
                    <div>-</div>
                    <div className={"u-textRight"}>
                      <ReplyArea assignmentUser={username} assignmentId={-1} onChange={updateAssignments} />
                    </div>
                  </div>
                </Grid>
            </Grid>
          : null}
        </Grid>
      </Grid>
    </div>
  );
}
